import React, { Component } from "react";
import {
    Col,
    Container,
    Row,
    Image,
    Card,
    ListGroup,
    Spinner,
} from "react-bootstrap";
import {
    BiArchive,
    BsClockHistory,
    BiConversation,
    BsPencilSquare,
    FaPen,
    HiMinusCircle,
} from "react-icons/all";
import DataTable from "react-data-table-component";
import {
    getAllCategory,
    deleteItem,
    clearCategory,
} from "../../../redux/actions/categoryAction";
import { connect, useDispatch, useSelector } from "react-redux";
import { getToken } from "../../../resources/utils";
import { deleteApi } from "../../../services/axios";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import swal from "sweetalert";
import { useState } from "react";
import Moment from "react-moment";
import "moment-timezone";
import { getLogUser } from "../../../redux/actions/logAction";
import { capitalizeFirstLetter } from "../../../resources/helpers";

const Category = (props) => {
    const dispatch = useDispatch();
    const categoryList = useSelector((state) => state.category);
    const { categories } = categoryList;
    const logList = useSelector((state) => state.log);
    const { logs } = logList;
    const [loading, setLoading] = useState(true);

    const createCategory = () => {
        props.history.push("/lms/category/create");
    };

    useEffect(() => {
        dispatch(getAllCategory());
        dispatch(clearCategory());
        dispatch(getLogUser("category"));
    }, [dispatch]);

    const handleDelete = (id) => {
        swal({
            title: "Apakah anda yakin?",
            text: "Data yang sudah dihapus tidak dapat dikembalikan!",
            icon: "warning",
            buttons: {
                cancel: "Batal",
                danger: {
                    text: "Hapus",
                    value: true,
                },
            },
            dangerMode: true,
        }).then((value) => {
            if (value) {
                const url = `category/delete/${id}`;
                const token = "Bearer " + getToken();
                const headers = {
                    headers: {
                        Authorization: token,
                    },
                };

                deleteApi(url, headers)
                    .then((res) => {
                        if (res.status !== "error") {
                            dispatch(getAllCategory());
                            swal("Data kategori berhasil dihapus!", {
                                icon: "success",
                            });
                        } else {
                            swal("Data kategori gagal dihapus!", {
                                icon: "error",
                                buttons: { cancel: "Kembali" },
                            });
                        }
                    })
                    .catch((err) => console.log(err));
            }
        });
    };

    const column = [
        {
            name: "Nama",
            cell: (category) => (
                <>
                    <div className="u-name">
                        {capitalizeFirstLetter(category.title)}
                    </div>
                </>
            ),
        },
        {
            name: "Kursus",
            cell: (category) => (
                <>
                    <span>{category.courses}</span>
                </>
            ),
        },
        {
            name: "Forum",
            cell: (category) => (
                <>
                    <span>{category.forums}</span>
                </>
            ),
        },
        {
            name: "Status",
            cell: (category) => (
                <>
                    <span className={`u-status ${category.status}`}>
                        {category.status}
                    </span>
                </>
            ),
            width: "120px",
        },
        {
            width: "80px",
            cell: (category) => (
                <>
                    <span>
                        <Link
                            className="btn-edit"
                            to={"category/edit/" + category.id}
                        >
                            <FaPen />
                        </Link>{" "}
                        |{" "}
                        <a
                            className="btn-delete"
                            onClick={() => handleDelete(category.id)}
                        >
                            <HiMinusCircle />
                        </a>
                    </span>
                </>
            ),
            right: true,
        },
    ];

    useEffect(() => {
        setTimeout(
            function () {
                setLoading(false);
            }.bind(this),
            2000
        );
    }, []);

    return (
        <div className="margin-t30">
            <Container fluid>
                <div className="top-header margin-b30">
                    <div className="title">
                        <BiArchive />
                        <h3>Kategori</h3>
                    </div>
                    <button onClick={createCategory} className="btn-transform">
                        <span className="btn-icon">
                            <BsPencilSquare />
                        </span>

                        <span className="btn-text">Tambah Baru</span>
                    </button>
                </div>
                <div className="user-body">
                    <Row>
                        <Col lg={8} xs={12}>
                            <Card className="min-h95p padding10 margin-b30">
                                {categories ? (
                                    <DataTable
                                        columns={column}
                                        data={categories}
                                        defaultSortFieldId={1}
                                        pagination
                                        paginationRowsPerPageOptions={[
                                            5, 10, 25, 50, 100,
                                        ]}
                                    />
                                ) : loading ? (
                                    <Spinner
                                        animation="border"
                                        className="p-absolute left50"
                                    />
                                ) : (
                                    <span className="p-absolute left50 transform-l50">
                                        Data tidak ditemukan
                                    </span>
                                )}
                            </Card>
                        </Col>
                        <Col lg={4} xs={12}>
                            <div className="side-block">
                                <Link to={"/lms/log"}>
                                    <div className="card-title border-r20">
                                        <span className="title-block">
                                            <BsClockHistory /> Aktivitas
                                        </span>
                                    </div>
                                    <ListGroup>
                                        {logs ? (
                                            logs.map((val, i) => (
                                                <ListGroup.Item>
                                                    <div className="padding-lr10">
                                                        <span className="text-label12">
                                                            <Moment
                                                                locale="id"
                                                                fromNow
                                                            >
                                                                {val.created_at}
                                                            </Moment>
                                                        </span>
                                                        <br />
                                                        {val.value}
                                                    </div>
                                                </ListGroup.Item>
                                            ))
                                        ) : (
                                            <Spinner
                                                animation="border"
                                                className="p-absolute left50"
                                            />
                                        )}
                                    </ListGroup>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="p-footer margin-b30"></div>
            </Container>
        </div>
    );
};

export default Category;
